export default {"src":"/_next/static/media/case_dots.b6b46f01.svg","height":429,"width":392,"blurWidth":0,"blurHeight":0};